export default "__VITE_ASSET__DRvBvpB6__"